import styled from 'styled-components';

export const Title = styled.div`
    /* font-weight: 600; */
    font-family: Roboto, sans-serif;
`